import MallIcon from '@/pages/DDM/components/MallIcon';
import { useAlertDialogStore } from '@/store/alertDialogStore';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, IconButton } from '@mui/material';

function AlertDialog() {
    const {
        isOpen,
        message,
        action: { setIsOpen },
    } = useAlertDialogStore((state) => {
        const { isOpen, message, action } = state;
        return { isOpen, message, action };
    });

    const handleClose = () => {
        setIsOpen(false);
    };

    return (
        <Dialog open={isOpen} onClose={handleClose} maxWidth={'xs'} sx={{ zIndex: 1500 }}>
            <IconButton onClick={handleClose} sx={{ position: 'absolute', right: '1%', top: '1%' }}>
                <MallIcon iconName="del" />
            </IconButton>
            <DialogContent>
                <DialogContentText marginTop={'20px'} textAlign='center'>
                    <b>{message}</b>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant='contained' onClick={handleClose}>확인</Button>
            </DialogActions>
        </Dialog>
    );
}

export default AlertDialog;
